import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';

import { Info } from 'basic-components/icons';

import classNames from 'classnames';

const InfoButtonPortal = ({ infoButtonPosition, onClick, onMouseEnter, onMouseLeave, rowIndex, symbol }) => createPortal(
  <div
      aria-label="Open row information"
      className={classNames(
        "ng-office-app__authed__content__results__body__info-button",
        "ng-office-app__authed__content__results__body__info-button--is-visible"
      )}
      key={rowIndex}
      onClick={event => {
        event.stopPropagation()
        onClick(symbol)
      }}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      role="button"
      style={infoButtonPosition}
      tabIndex={0}
  >
    <div className="ng-office-app__authed__content__results__body__info-button__icon">
      <Info 
          color="blue-bright" 
          height={16} 
          width={16}
      />
    </div>
  </div>,
  document.body
)

InfoButtonPortal.propTypes = {
  infoButtonPosition: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
  onMouseEnter: PropTypes.func.isRequired,
  onMouseLeave: PropTypes.func.isRequired,
  rowIndex: PropTypes.number,
  symbol: PropTypes.object.isRequired
}

export default InfoButtonPortal
